export const WEAK_PASSWORD_STATUS = 'weak'
export const OKAY_PASSWORD_STATUS = 'okay'
export const STRONG_PASSWORD_STATUS = 'strong'
